import React, {Component} from 'react';
import {TopButtonAction, TopButtonCancel} from "../../../../../componentsTopsa/buttons/TopButtons";
import {ControlLabel, FormControl} from "react-bootstrap";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";

class PopupZmienKursWBilecie extends Component {

    state={
        nowyKurs:''
    }

    onClickZmienKurs = () =>{
        this.props.handleClickZmienKurs(this.props.bilet.idBi,parseInt(this.state.nowyKurs))
    }

    render() {
        return (
            <div id={'EBUSModalContainerBG'}>
                <div id={'modalContainer'}>
                    <div id={'modalTextContent'} style={{minWidth: "800px"}}>
                        <div id={'ZmienKursPopup'}>
                            <h4>Zmień kurs na bilecie o id {this.props.bilet.idBi}</h4>
                            <ControlLabel>Podaj numer innego kursu</ControlLabel>
                            <FormControl type={'number'} onChange={(e)=>this.setState({nowyKurs:e.target.value})}/>
                            <TopAlertUwaga text={'Należy uważnie wprowadzać dane!'}/>
                            <div style={{marginTop: "5px"}}>
                                <div className={'pull-right'}>
                                    <TopButtonCancel onClick={this.props.onClickAnuluj}/>
                                    <TopButtonAction text={'Wyslij'} iconType={'fa fa-send'} onClick={this.onClickZmienKurs} btnSize={'md'}/>
                                </div>
                                <div className={"clearfix"}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopupZmienKursWBilecie;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/PopupZmienKursWBilecie.js